<template>
  <div>
    <load-profile></load-profile>
    <b-card ref="container" id="container">
      <b-card-text class="mb-2">
        <h5>{{ $t("general.manageSystemSettings") }}</h5>
      </b-card-text>
      <b-card-text class="mb-2">
        <h4>{{ $t("general.dailySummary") }}</h4>
      </b-card-text>
      <b-form-checkbox name="summary-toggle" switch>
        <p class="font-weight-bold">{{ $t("button.enable") }}</p>
      </b-form-checkbox>
      <b-card-text>
        {{ $t("general.dailySummaryDescription") }}
      </b-card-text>
      <div class="d-flex flex-row align-items-center mb-2">
        <h5 class="mr-2">
          {{ $t("general.timeToSend") }}
        </h5>
        <b-form-input type="time" class="time-input"></b-form-input>
      </div>
      <div class="d-flex flex-row justify-content-end">
        <b-button variant="primary">{{ $t("button.save") }}</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardText,
  BFormCheckbox,
  BFormInput,
  BButton,
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BCardText,
    BFormCheckbox,
    BFormInput,
    BButton,
  },
  setup() {
    const permissionType = "general-settings";
    return { permissionType };
  },
};
</script>

<style class="scss" scoped>
.time-input {
  width: auto;
  max-width: 200px;
}
</style>
